import { ReactNode } from 'react';
import { ResourceItemType } from '@features/components/ResourceCards';
import { noop } from 'lodash-es';
import { MdCheck } from 'react-icons/md';

const MenuItemWithWarning = ({ show, children, message }: { show?: boolean; children: ReactNode; message: string }) => {
  return (
    <div className="flex flex-col">
      {children}
      {show && <span className="text-s-r text-base-20">{message}</span>}
    </div>
  );
};

interface IGetUserMenuItemsParams {
  onDetachPress: () => void;
  onRemovePrimaryPress?: () => void;
  onSetAsPrimaryPress?: () => void;
  handleSetIsPrimaryUser?: () => void;
  isPrimaryChangeAvailable?: boolean;
  isPrimary?: boolean;
  blockIsPrimaryModal?: boolean;
  caseId?: string;
  isLastOnCaseMandatory?: boolean;
}

export const getUserMenuItems = ({
  onDetachPress,
  onRemovePrimaryPress,
  onSetAsPrimaryPress,
  handleSetIsPrimaryUser,
  isPrimaryChangeAvailable,
  isPrimary,
  blockIsPrimaryModal,
  caseId,
  isLastOnCaseMandatory,
}: IGetUserMenuItemsParams): ResourceItemType[] => {
  const getPrimaryMenuAction = () => {
    if (isPrimary && onRemovePrimaryPress) {
      return onRemovePrimaryPress;
    }

    if (!isPrimary && caseId && !blockIsPrimaryModal && onSetAsPrimaryPress) {
      return onSetAsPrimaryPress;
    }

    if (!isPrimary && caseId && blockIsPrimaryModal && handleSetIsPrimaryUser) {
      return handleSetIsPrimaryUser;
    }

    return noop;
  };

  const menuItems = [
    {
      key: 'detach',
      label: (
        <MenuItemWithWarning show={isLastOnCaseMandatory} message="Last on case: Can not be detached">
          Detach from Case
        </MenuItemWithWarning>
      ),
      color: 'danger' as ResourceItemType['color'],
      onUserMenuPress: onDetachPress,
    },
  ] as ResourceItemType[];

  if (isPrimaryChangeAvailable) {
    menuItems.unshift({
      key: 'primary',
      label: (
        <MenuItemWithWarning show={isLastOnCaseMandatory} message="Last on case: Can not be removed">
          Primary for case
        </MenuItemWithWarning>
      ),
      color: 'primary' as ResourceItemType['color'],
      startContent: isPrimary ? <MdCheck /> : undefined,
      onUserMenuPress: getPrimaryMenuAction(),
    });
  }

  return menuItems;
};
